import { render } from "./idpwchk.vue?vue&type=template&id=401509fd"
import script from "./idpwchk.vue?vue&type=script&lang=js"
export * from "./idpwchk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__